import { RevealSection } from '../RevealSection'

import { Kicker } from '@/components/Kicker'
import RichText from '@/components/RichText'
import { RenderLink } from '@/heros/HeroCenter'
import { cn } from '@/utilities/ui'

import type { Page } from '@/payload-types'

export const SectionHero: React.FC<Page['hero']> = ({ links, richText, heroUncontained }) => {
  return (
    <div className="relative flex w-full items-center justify-center rounded-2xl py-20 xl:py-[125px]">
      <RevealSection stagger className="relative z-20 wrapper md:max-w-lg">
        {heroUncontained?.mainHeading && (
          <h1
            className={cn(
              'text-foreground',
              'text-center font-family-display text-4xl sm:text-5xl md:text-6xl',
            )}
          >
            {heroUncontained?.kicker && (
              <Kicker className="mx-auto mb-2 w-fit">{heroUncontained.kicker}</Kicker>
            )}
            {heroUncontained.mainHeading}
          </h1>
        )}
        {richText && (
          <RichText
            className={cn('mx-2 my-4 text-center md:m-6')}
            data={richText}
            enableGutter={false}
            fontOverride="font-family-body leading-7 text-base sm:text-xl text-foreground"
          />
        )}
        {Array.isArray(links) && links.length > 0 && (
          <ul className="flex justify-center gap-4">
            {links.map(({ link }, i) => {
              return (
                <li key={i}>
                  <RenderLink link={link} color={i % 2 === 0 ? 'evergreen' : 'outlinePrimary'} />
                </li>
              )
            })}
          </ul>
        )}
      </RevealSection>
    </div>
  )
}
